import React, { useState, useEffect } from 'react';
import { useInView } from 'react-intersection-observer';
import { motion } from 'framer-motion';

const ServiceCard = ({ service, index }) => {
  const [isFlipped, setIsFlipped] = useState(false);
  const [ref, inView] = useInView({
    triggerOnce: true,
    threshold: 0.1,
  });

  const cardVariants = {
    hidden: { opacity: 0, y: 20 },
    visible: { opacity: 1, y: 0 },
  };

  return (
    <motion.div
      ref={ref}
      initial="hidden"
      animate={inView ? 'visible' : 'hidden'}
      variants={cardVariants}
      transition={{ duration: 0.5, delay: index * 0.1 }}
      className="service-card"
      onMouseEnter={() => setIsFlipped(true)}
      onMouseLeave={() => setIsFlipped(false)}
    >
      <div className={`card-inner ${isFlipped ? 'is-flipped' : ''}`}>
        <div className="card-front">
          <div className="content">
            <img src={service.image} alt={service.title} className="service-image" />
            <div className="icon">{service.icon}</div>
            <h3>{service.title}</h3>
          </div>
        </div>
        <div className="card-back">
          <div className="content">
            <h3>{service.title}</h3>
            <p>{service.description}</p>
            <a href={service.link} className="know-more-btn">
              KNOW MORE
            </a>
          </div>
        </div>
      </div>
    </motion.div>
  );
};

const ServiceSection = () => {
  const services = [
    {
      id: 1,
      title: 'TELECOM & IOT SERVICES',
      description:
        'We offer tailored solutions to monitor and connect your business branches, deliver high-speed internet, and implement innovative IoT solutions, all designed to enhance efficiency and cost-effectiveness.',
      image: '/communication.png',
      link: '/services',
    },
    {
      id: 2,
      title: 'CLOUD COMMUNICATIONS',
      description:
        'We deliver unified voice, video meetings, team messaging, and digital customer engagement solutions, with integrated contact center services, to meet the communication needs of enterprises worldwide.',
        image: '/chitchat.png',
      link: '/services',
    },
    {
      id: 3,
      title: 'AI & DATA WAREHOUSE',
      description:
        'We provide SAP and Oracle development, Microsoft services, and expert data warehousing solutions, alongside consulting services, to help you manage and maximize your data effectively.',
        image: '/artificial-intelligence.png',
      link: '/services',
    },
  ];
  
  

  return (
    <div className="service-section">
      <h2 className="service-heading">WHAT WE OFFER</h2>
      <p style={{
        color: 'rgb(65, 64, 66)',
        fontFamily: '"Inter", sans-serif',
        fontSize: '16px',
        lineHeight: '24px',
        fontWeight: 400,
        fontStyle: 'normal',
        textAlign: 'center',
        maxWidth: '900px',
        margin: '0 auto 25px'
      }}>
        At Ejil Enterprise, we provide a range of services tailored to meet your business needs. From telecom solutions to AI-driven analytics, we empower your organization to achieve greater efficiency and innovation.
      </p>
      <div className="service-cards-container">
        {services.map((service, index) => (
          <ServiceCard key={service.id} service={service} index={index} />
        ))}
      </div>

      <style jsx>{`
        .service-section {
          padding: 40px;
          background-color: white;
          text-align: center;
        }

        .service-image {
          width: 80px; /* Adjust as needed */
    height: 80px;
    object-fit: cover;
    margin-top:35px;
    margin-bottom: 15px;
    border-radius: 8px;
  }
        .service-heading {
          color: #410684;
          font-family: 'Oswald', sans-serif;
          font-size: 60px;
          line-height: 72px;
          font-weight: 700;
          margin-bottom: 20px;
          width: 100%;
        }

        .service-cards-container {
          display: flex;
          justify-content: center;
          flex-wrap: wrap;
        }


        /* Adjusted card dimensions for "Why Choose Us" style */
        .service-card {
          width: 350px;
          height: 250px;
          perspective: 1000px;
          margin: 15px;
        }

        .card-inner {
          position: relative;
          width: 100%;
          height: 100%;
          transition: transform 0.6s;
          transform-style: preserve-3d;
        }

        .is-flipped {
          transform: rotateY(180deg);
        }

        .card-front,
        .card-back {
          position: absolute;
          width: 100%;
          height: 100%;
          backface-visibility: hidden;
          display: flex;
          flex-direction: column;
          justify-content: center;
          align-items: center;
          padding: 20px;
          border-radius: 15px;
          box-shadow: 0 4px 10px rgba(0, 0, 0, 0.1);
          background-color: #F1F2F4;
        }

        .card-back {
          transform: rotateY(180deg);
        }

        .content {
          display: flex;
          flex-direction: column;
          align-items: center;
          text-align: center;
          height: 100%;
        }

        .icon {
          font-size: 50px;
          margin-bottom: 10px;
          transition: transform 0.3s ease;
        }

        .service-card:hover .icon {
          transform: scale(1.2);
        }

        h3 {
          font-size: isMobile ?'12px':'0.5rem';
          color: #410684;
          font-family: 'Oswald', sans-serif;
          
          font-weight: 600;
          line-height: 26px;
          margin-bottom: isMobile ?'3px':'10px';
        }

        p {
          color: #414042;
          font-family: 'Inter', sans-serif;
          font-size: 0.875rem;
          font-weight:400;
          line-height:20px;
          margin-top:5px;
          text-align: justify;
          margin-bottom: 15px;
        }

        .know-more-btn {
          background-color: #DC2666;
          color: white;
          Font-weight:500;
          font-family: 'Oswald', sans-serif;
          padding: 8px 20px;
          text-decoration: none;
          border-radius: 5px;
          transition: background-color 0.3s ease;
        }

        .know-more-btn:hover {
          background-color: #C2225B;
        }
      `}</style>
    </div>
  );
};

export default ServiceSection;
